import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../common/formElements/CustomSelect';

export class ExternalApiTaskSchedule extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, actions, version } = this.props;
    actions.loadExternalApisInSchedule({ projectId, version });
  }

  handleSubmit = (values) => {
    this.props.handleSubmit(values);
  };

  scheduleSchema = () => {
    const { taskDetail } = this.props;
    let externalApiUuid = '';
    if (taskDetail && taskDetail.settings) {
      externalApiUuid = taskDetail.settings.externalApiUuid;
    }
    return {
      externalApiUuid,
    };
  };

  scheduleSchemaValidation = () => {
    let validationSchema = {
      externalApiUuid: Yup.string().required("Email Template can't be blank."),
    };
    return Yup.object().shape(validationSchema);
  };

  handleCancel = () => {
    const { projectId, version, history } = this.props;
    history.push(`/schedule/${version}/v/${projectId}/`);
  };

  render() {
    const { schedule, taskDetail, isReadOnly } = this.props;
    const { loadExternalApisInSchedulePending, externalApis, updateSchedulePending } = schedule;
    const apiOptions = externalApis.map((api) => ({ label: api.externalApiName, value: api.uuid }));
    return (
      <div className="schedule-external-api-task-schedule">
        {loadExternalApisInSchedulePending && (
          <div className="text-center">
            <CustomLoader loading={loadExternalApisInSchedulePending} size="20px" color="#303453" />
          </div>
        )}
        <Formik
          enableReinitialize={true}
          initialValues={this.scheduleSchema()}
          validationSchema={this.scheduleSchemaValidation()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            !isReadOnly && this.handleSubmit(values);
            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched }) => (
            <Form className="form-horizontal">
              <div className="row">
                <div className="col-md-6 col-lg-6 col-sm-6">
                  <CustomInputWithIcon icon="text" required={true} title="External API">
                    {taskDetail.externalApiUuid}
                    <CustomSelect
                      name="externalApiUuid"
                      isMulti={false}
                      options={apiOptions}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      placeholder="External API"
                      value={values.externalApiUuid}
                    />
                    <p className="text-danger">
                      <ErrorMessage name="externalApiUuid" />
                    </p>
                  </CustomInputWithIcon>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6  ">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-md"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                </div>
                <div className="col-md-6 text-right">
                  <button
                    type="submit"
                    className="btn btn-theme-submit btn-md"
                    disabled={updateSchedulePending || isReadOnly}
                    title={isReadOnly && 'Read-Only Mode'}
                  >
                    Schedule
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    schedule: state.schedule,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalApiTaskSchedule);
